import React from 'react';
import { useIntl } from 'react-intl';
import { formatMeasurement } from '../../utils/formatMeasurement';
import ClosestToPin from '../icons/ClosestToPin';
import LongestDrive from '../icons/LongestDrive';
import StraightestDrive from '../icons/StraightestDrive';
import { ContestResultType } from '../../utils/contestTypes';
export default function SingleContest(_a) {
    var contest = _a.contest, measurementUnit = _a.measurementUnit;
    var intl = useIntl();
    var getIconElement = function () {
        if (contest === null || contest === void 0 ? void 0 : contest.type) {
            var elementOptions = {
                closestToPin: React.createElement(ClosestToPin, { style: { width: '36px', height: '25px' } }),
                longestDrive: React.createElement(LongestDrive, null),
                straightestDrive: React.createElement(StraightestDrive, null)
            };
            return elementOptions[contest.type];
        }
        return React.createElement(React.Fragment, null);
    };
    var getContestType = function () {
        var contestType = contest === null || contest === void 0 ? void 0 : contest.type;
        return contestType ? intl.formatMessage({ id: "leaderboard.".concat(contestType) }) : '';
    };
    var getFullName = function (player) {
        var firstName = player.firstName, lastName = player.lastName;
        return "".concat(firstName, " ").concat(lastName);
    };
    var getResult = function (entry) {
        return (contest === null || contest === void 0 ? void 0 : contest.measured)
            ? formatMeasurement(entry.score, measurementUnit, [ContestResultType.CLOSEST_TO_PIN, ContestResultType.STRAIGHTEST_DRIVE].includes(contest === null || contest === void 0 ? void 0 : contest.type))
            : '';
    };
    //TODO: Remove this sorting when https://golfgamebook.atlassian.net/browse/CORE-1318 is done
    var sortedEntries = contest === null || contest === void 0 ? void 0 : contest.entries;
    if ((contest === null || contest === void 0 ? void 0 : contest.type) === ContestResultType.CLOSEST_TO_PIN) {
        sortedEntries = contest.entries.slice().sort(function (a, b) { return a.score - b.score; });
    }
    return (React.createElement("div", { className: "game-contests-single" },
        React.createElement("div", { className: "game-contests-single-header" },
            React.createElement("div", { className: "game-contests-single-header-icon" }, getIconElement()),
            React.createElement("div", { className: "game-contests-single-header-type" }, getContestType()),
            React.createElement("div", { className: "game-contests-single-header-hole" },
                intl.formatMessage({ id: 'leaderboard.hole' }),
                " ", contest === null || contest === void 0 ? void 0 :
                contest.holeNumber)), sortedEntries === null || sortedEntries === void 0 ? void 0 :
        sortedEntries.filter(function (entry) { return entry.score >= 0; }).map(function (entry, i) { return (React.createElement("div", { key: i, className: "game-contests-single-player" },
            React.createElement("div", { className: "game-contests-single-player-position" },
                entry.position,
                "."),
            React.createElement("div", { className: "game-contests-single-player-name" }, getFullName(entry.user)),
            React.createElement("div", { className: "game-contests-single-player-result" }, getResult(entry)))); })));
}
